// Exact bare-root route. More specific than the '/*' catch-all, so it takes
// over '/' and server-redirects to a language home instead of letting the CSR
// shell client-redirect (which leaves '/' as a 200 empty shell for crawlers).
export default '/'
